import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ChecklistPage from './component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { createLandlord } from '@rental-manager/actions/requests';
import { acceptTerms as saveAcceptTerms } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { LANDLORD_STATUS } from '@rental-manager/constants/OnboardingConstants';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId, acceptTerms }) => ({
  email: state.user.email,
  acceptTerms: state.payments.landlord.onboarding[propertyId]?.acceptTerms || acceptTerms,
  leasesForProperty: state.payments.landlord.onboarding[propertyId].leasesForProperty,
  user: state.user,
  currentProperty: state.payments.landlord.property.listingDetails,
});

const mapDispatchToProps = (dispatch, { baseUrl, propertyId, landlordStatus }: any) => ({
  onSubmit: ({ email, acceptTerms, leasesForProperty }) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveAcceptTerms({ propertyId })))
      .then(() => {
        if (landlordStatus === LANDLORD_STATUS.NOT_STARTED) {
          const payload = {
            acceptTerms,
            email,
          };
          return dispatch(createLandlord({ propertyId, ...payload }));
        }
        return { success: true };
      })
      .then(checkRequestActionSuccess)
      .then(async () => {
        dispatch(
          push({
            pathname:
              baseUrl +
              (leasesForProperty.length > 0 ? paths.onboarding.leaseSelectorPage : paths.onboarding.rentAmountPage),
            search: 'acceptTerms=true',
          }),
        );
      })
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup))),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: () => {
    const { email, acceptTerms, leasesForProperty } = stateProps;
    return dispatchProps.onSubmit({
      email,
      acceptTerms,
      leasesForProperty,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ChecklistPage);
